import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {SigninComponent} from './signin/signin.component';
import {AuthRoutingModule} from './auth-routing.module';
import {AuthService} from './auth.service';
import {AuthGuard} from './auth-guard.service';
import {RuoloService} from '../+configurazione/ruolo/ruolo.service';
import {PersonaService} from '../+anagrafica/persona/persona.service';
import {PersonaEntitaOrganizzativaService} from '../+anagrafica/personaentitaorganizzativa/personaentitaorganizzativa.service';
import {FasciaEntitaOrganizzativaService} from '../+anagrafica/fasciaentitaorganizzativa/fasciaentitaorganizzativa.service';
import {RuoloPersonaService} from '../+anagrafica/ruolopersona/ruolopersona.service';
import {GerarchiaService} from '../+anagrafica/gerarchia/gerarchia.service';
import {EntitaLocaleService} from '../+anagrafica/entitalocale/entitalocale.service';
import {EntitaOrganizzativaService} from '../+anagrafica/entitaorganizzativa/entitaorganizzativa.service';
import {TipoEntitaLocaleService} from '../+configurazione/tipoentitalocale/tipoentitalocale.service';
import {TipoGerarchiaStrutturaService} from '../+configurazione/tipogerarchiastruttura/tipogerarchiastruttura.service';
import {TipoEntitaOrganizzativaService} from '../+configurazione/tipoentitaorganizzativa/tipoentitaorganizzativa.service';
import {TipoGerarchiaService} from '../+configurazione/tipogerarchia/tipogerarchia.service';
import {ContestoService} from '../+configurazione/contesto/contesto.service';
import {RuoloUtenteService} from '../+configurazione/ruoloutente/ruoloutente.service';
import {CruscottoService} from '../+configurazione/cruscotto/cruscotto.service';
import {UtenteService} from '../+configurazione/utente/utente.service';
import {GerarchiaTreeService} from '../+anagrafica/gerarchia-tree/gerarchia-tree.service';
import {TipoEntitaOrganizzativaAttributoService} from '../+configurazione/tipoentitaorganizzativa/tipoentitaorganizzativaattributo/tipoentitaorganizzativaattributo.service';
import {CategoriaTipiEoService} from '../+configurazione/categoriatipieo/categoriatipieo.service';
import { DelegaService } from '../+anagrafica/delega/delega.service';
import { FasciaService } from '../+configurazione/fascia/fascia.service';
import { RuoloPersonaProvvService } from '../+anagrafica/ruolopersona/ruolopersona-provv.service';

export enum ServiceReg {
  PERSONA = 'persona',
  ENTITA_ORGANIZZATIVA = 'entitaOrganizzativa',
  ENTITA_LOCALE = 'entitaLocale',
  GERARCHIA = 'gerarchia',
  RUOLO_PERSONA = 'ruoloPersona',
  RUOLO_PERSONA_PROVV = 'ruoloPersonaProvv',
  PERSONA_ENTITA_ORGANIZZATIVA = 'personaEntitaOrganizzativa',
  FASCIA_ENTITA_ORGANIZZATIVA = 'fasciaEntitaOrganizzativa',
  RUOLO = 'ruolo',
  UTENTE = 'utente',
  RUOLO_UTENTE = 'ruoloUtente',
  CRUSCOTTO = 'cruscotto',
  CONTESTO = 'contesto',
  FASCIA = 'fascia',
  TIPO_GERARCHIA = 'tipoGerarchia',
  TIPO_ENTITA_ORGANIZZATIVA = 'tipoEntitaOrganizzativa',
  TIPO_ENTITA_ORGANIZZATIVA_ATTRIBUTO = 'tipoEntitaOrganizzativaAttributo',
  CATEGORIA_TIPI_EO = 'categoriaTipiEo',
  TIPO_GERARCHIA_STRUTTURA = 'tipoGerarchiaStruttura',
  TIPO_ENTITA_LOCALE = 'tipoEntitaLocale',
  GERARCHIA_TREE = 'gerarchia-tree',
  DELEGA = 'delega'
}

@NgModule({
  declarations: [
    SigninComponent
  ],
  imports: [
    FormsModule,
    AuthRoutingModule
  ],
  providers: [
    AuthService,
    AuthGuard,

    PersonaService, {provide: ServiceReg.PERSONA, useExisting: PersonaService},
    EntitaOrganizzativaService, {provide: ServiceReg.ENTITA_ORGANIZZATIVA, useExisting: EntitaOrganizzativaService},
    EntitaLocaleService, {provide: ServiceReg.ENTITA_LOCALE, useExisting: EntitaLocaleService},
    GerarchiaService, {provide: ServiceReg.GERARCHIA, useExisting: GerarchiaService},
    RuoloPersonaService, {provide: ServiceReg.RUOLO_PERSONA, useExisting: RuoloPersonaService},
    RuoloPersonaProvvService, {provide: ServiceReg.RUOLO_PERSONA_PROVV, useExisting: RuoloPersonaProvvService},
    PersonaEntitaOrganizzativaService, {provide: ServiceReg.PERSONA_ENTITA_ORGANIZZATIVA,
      useExisting: PersonaEntitaOrganizzativaService},
    FasciaEntitaOrganizzativaService, {provide: ServiceReg.FASCIA_ENTITA_ORGANIZZATIVA,
      useExisting: FasciaEntitaOrganizzativaService},
  
    RuoloService, {provide: ServiceReg.RUOLO, useExisting: RuoloService},
    UtenteService, {provide: ServiceReg.UTENTE, useExisting: UtenteService},
    RuoloUtenteService, {provide: ServiceReg.RUOLO_UTENTE, useExisting: RuoloUtenteService},
    CruscottoService, {provide: ServiceReg.CRUSCOTTO, useExisting: CruscottoService},
    ContestoService, {provide: ServiceReg.CONTESTO, useExisting: ContestoService},
    FasciaService, {provide: ServiceReg.FASCIA, useExisting: FasciaService},
    TipoGerarchiaService, {provide: ServiceReg.TIPO_GERARCHIA, useExisting: TipoGerarchiaService},
    TipoEntitaOrganizzativaService, {provide: ServiceReg.TIPO_ENTITA_ORGANIZZATIVA,
      useExisting: TipoEntitaOrganizzativaService},
    TipoEntitaOrganizzativaAttributoService, {provide: ServiceReg.TIPO_ENTITA_ORGANIZZATIVA_ATTRIBUTO,
      useExisting: TipoEntitaOrganizzativaAttributoService},
    CategoriaTipiEoService, {provide: ServiceReg.CATEGORIA_TIPI_EO, useExisting: CategoriaTipiEoService},
    TipoGerarchiaStrutturaService, {provide: ServiceReg.TIPO_GERARCHIA_STRUTTURA, useExisting: TipoGerarchiaStrutturaService},
    TipoEntitaLocaleService, {provide: ServiceReg.TIPO_ENTITA_LOCALE, useExisting: TipoEntitaLocaleService},
    GerarchiaTreeService, {provide: ServiceReg.GERARCHIA_TREE, useExisting: GerarchiaTreeService},
    DelegaService, {provide: ServiceReg.DELEGA, useExisting: DelegaService},
  ]
})
export class AuthModule {}
